import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import * as AuthActions from '@app/store/auth/auth.actions';
import { AppState } from '../../store/index';
import { Store } from '@ngrx/store';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private store: Store<AppState>
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                if (err.status === 401) {
                    // Cierre automático de sesión si la API devuelve 401.
                    this.store.dispatch(new AuthActions.DoLogout(true));
                }

                // El visor necesita distinguir un conflicto de revisión sin perder su estado HTTP.
                const sharedAnnotations = /\/groups\/[^/]+\/books\/[^/]+\/chapters\/[^/]+\/annotations(?:\?|$)/.test(request.url);
                const personalAnnotations = /\/books\/[^/]+\/saveChapterConfig\/[^/]+(?:\?|$)/.test(request.url);
                if ((err.status === 409 && sharedAnnotations) || (err.status === 413 && (sharedAnnotations || personalAnnotations))) {
                    return throwError(err);
                }

                let error = err.statusText || 'Error desconocido';

                if (err.error) {
                    if (typeof err.error === 'string') {
                        error = err.error;
                    } else if (err.error.message) {
                        error = err.error.message;
                    }
                }

                return throwError(error);
            })
        );
    }
}
